import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
import config from "appConfig";

const items = [
  {
    id: "c876f684-4f90-468e-89cd-c7228e594239",
    content: "Bare load-bearing slab",
    options: { image: `${config.ASSETS_URL}/05/19/task/task-3-item-1.svg` },
  },
  {
    id: "5d25ce23-8c5e-4ca6-8e51-5128947d44d2",
    content: "Covered load-bearing slab",
    options: { image: `${config.ASSETS_URL}/05/19/task/task-3-item-2.svg` },
  },
  {
    id: "ebf9f1d9-6af4-4e04-8be9-48ff2e0d6fb9",
    content: "Floating floor</br>on the load-bearing slab",
    options: { image: `${config.ASSETS_URL}/05/19/task/task-3-item-3.svg` },
  },
  {
    id: "235950c4-68f5-4d74-9477-7ce0ad0117b3",
    content: "Floating floor with a cover</br>on the load-bearing slab",
    options: { image: `${config.ASSETS_URL}/05/19/task/task-3-item-4.svg` },
  },
];

export const task: Task = {
  id: "afc0e1d5-56d7-413a-9ca7-7ca5457c97c7",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    columns: 2,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["235950c4-68f5-4d74-9477-7ce0ad0117b3"],
};
